
import { RevPicker } from '@backmarket/design-system'

import Picker from '../Picker'

import {
  COLS_CLASS_DEFAULT,
  COLS_CLASS_OVERRIDES,
  MAX_PICKER_ITEMS,
} from './PickerGroup.constants'
import translations from './PickerGroup.translations'

export default {
  components: {
    Picker,
    RevPicker,
  },
  props: {
    picker: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      displayAllItems: false,
    }
  },
  computed: {
    translations: () => translations,

    itemsToDisplay() {
      if (this.isItemsLengthHigherThanMax && !this.displayAllItems) {
        return this.picker.items.slice(0, this.maximumAmountOfItemsToShow)
      }

      return this.picker.items
    },

    isItemsLengthHigherThanMax() {
      return this.picker.items.length > MAX_PICKER_ITEMS
    },

    remainingItemsCount() {
      return this.picker.items.length - this.maximumAmountOfItemsToShow
    },

    maximumAmountOfItemsToShow() {
      return MAX_PICKER_ITEMS - 1
    },

    togglerLabel() {
      const { showMore, showLess } = this.translations

      return this.displayAllItems
        ? this.$t(showLess)
        : this.$t(showMore, { remaining: this.remainingItemsCount })
    },

    pickerTitle() {
      return this.picker.label
    },

    pickerId() {
      return this.picker.id
    },

    gridColumnsClass() {
      return COLS_CLASS_OVERRIDES[this.pickerId] ?? COLS_CLASS_DEFAULT
    },
  },

  methods: {
    toggleDisplayAllItems() {
      this.displayAllItems = !this.displayAllItems
    },
  },
}
